import Typography from "@mui/material/Typography";
import styles from "./user.module.scss";
import commonStyles from "../../../App.module.scss";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";
import { useState, useEffect, useRef } from "react";
import deleteIcon from "../../../assets/svg/delete_outline.svg";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import familyIcon from "../../../assets/familymember.svg";
import FamilyDetails from "./familyDetails";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import { object, string, ValidationError } from "yup";
import dayjs, { locale } from "dayjs";
import {
  CustomCalendarTodayOutlinedIcon,
  CustomTextFeild,
  CustomInputLabel,
  CustomDatePicker,
  CustomCheckbox,
  StyledDateContainer,
  CustomSelect,
  CustomEditIcon,
  CustomDeleteIcon,
  CommonButton,
  CustomRequiredInputLabel,
  CustomMenuItem,
  CommonOutlinedButton,
  ContactNumberInput,
  CustomCloseIcon,
  CustomCityStateTextField,
} from "../StyledComponents/StyledFields";
import { useAsyncError, useNavigate, useParams } from "react-router-dom";
import { isEmpty, isNil } from "lodash";
import { display } from "html2canvas/dist/types/css/property-descriptors/display";
import toast from "react-hot-toast";
import constants from "../../../config/constants.json";
import ToastSuccess from "../toast/toastSuccess";
import ToastError from "../toast/toastError";
import {
  apiRequest,
  catchErrorMessageHandler,
  getDevoteeId,
  getUserSelectedRole,
} from "../../../infrastructure/backendService";
import EmptyPage from "../emptyPages/emptyPage";
import {
  registerEventsProps,
  relationListProps,
  specialEventsListProps,
} from "../../../infrastructure/GlobalContextProvider";
import GridTableComponent from "../GridTableComponent/gridTableTemplate";
import ToastComponent from "../toastComponent";
import apiPath from "../../../config/apiPaths.json";
import updateIcon from "../../../assets/svg/update_outline.svg";
import LOCALE from "../../../config/en-us.json";
import CONSTANTS from "../../../config/constants.json";
import SuccessPopup from "../../devotee/donation/successPopup";
import ErrorPopup from "../ErrorPopup";
import { displayPhoneNumberFormattoPlain } from "../phoneNumberFormats/phoneNumberFormats";

interface ErrorMessageTypes {
  firstName: string;
  middleName: string;
  lastName: string;
  dateOfBirth: string;
  weddinganniversary: string;
  preferedlanguage: string;
  nakshatram: string;
  gothram: string;
  chandramana: string;
  souramana: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  country: string;
  email: string;
  phoneNumber: string;
}

interface DeleteDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
}
interface Event {
  eventId: any;
  eventName: string;
  date: string;
  subscribedEvent: string;
  subscriptionDate: string;
  relation: string;
}

export default function UserDetails() {
  const [showFamilyForm, setShowFamilyForm] = useState<boolean>(false);
  const [showFamilyButton, setShowFamilyButton] = useState<boolean>(true);
  const [showSpecialEventsForm, setShowSpecialEventsForm] =
    useState<boolean>(false);
  const [showAddMoreFields, setShowAddMoreFields] = useState<boolean>(false);
  const [showAddMoreButton, setShowAddMoreButton] = useState<boolean>(true);
  const [specialEventsList, setSpecialEventsList] = useState<
    specialEventsListProps[]
  >([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [addedItemsList, setAddedItemsList] = useState<Event[]>([]);
  const [buttonDisable, setButtonDisable] = useState(true);
  const [specialEventsData, setSpecialEventsData] = useState<any[]>([]);
  const [selectedId, setSelectedId] = useState<any | null | undefined>(null);
  const [selectedSpecialId, setSelectedSpecialId] = useState<
    any | null | undefined
  >(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false);
  const [nakshatramList, setNakshatramList] = useState([]);
  const [updateButton, setUpdateButton] = useState<boolean>(false);
  const [showSpecialAddMoreButton, setShowSpecialAddMoreButton] =
    useState<boolean>(true);
  const [selectedEvent, setSelectedEvent] = useState<registerEventsProps>({
    eventName: "",
    id: 0,
    isDateDependent: false,
    relation: "",
  });
  const [selectedRelation, setSelectedRelation] = useState<registerEventsProps>(
    {
      eventName: "",
      id: 0,
      isDateDependent: false,
      relation: "",
    }
  );

  const [eventsList, setEventsList] = useState<any[]>([]);
  const tableRef = useRef(null);
  const [familyData, setFamilyData] = useState<any[]>([]);
  const [familyId, setFamilyId] = useState<null | number>(null);
  const [specialEventsDataList, setSpecialEventsDataList] = useState<any[]>([]);
  const [familyMemberList, setFamilyMemberList] = useState<any[]>([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [relationList, setRelationList] = useState<any[]>([]);
  const [languageItems, setLanguageItems] = useState<any[]>([]);
  const [specialEventsById, setSpecialEventsById] = useState({});
  const [showAddButton, setShowAddButton] = useState<boolean>(true);
  const [showFamilyAddMoreButton, setShowFamilyAddMoreButton] =
    useState<boolean>(true);
  const [changesMade, setChangesMade] = useState(false);
  const formFields = {
    firstName: "",
    middleName: "",
    lastName: "",
    dateOfBirth: "",
    weddinganniversary: "",
    preferedlanguage: "",
    nakshatram: "",
    gothram: "",
    chandramana: "",
    souramana: "",
    address: "",
    city: "",
    state: "",
    zipcode: "",
    country: "",
    email: "",
    phoneNumber: "",
  };
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    ...formFields,
  });
  const hasManagerLevelRole = CONSTANTS.showDashBoardForRoles.includes(
    getUserSelectedRole() || ""
  );
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const validationSchema = object().shape({
    firstName: string().required("First Name is required"),
    lastName: string().required("Last Name is required"),
    dateOfBirth: string().required("DOB is required"),
    // weddinganniversary: string().required('wedding anniversary is required'),
    // preferedlanguage: string().required('Prefered Language is required'),
    email: string()
      .required("Email is required")
      .matches(emailRegex, "Please enter valid email address")
      .min(6, "Email must be at least 6 characters")
      .max(64, "Email cannot exceed 64 characters"),
    // address: string().required('Address is required'),
    country: string().required("Country is required"),
    city: string().required("city is required"),
    state: string().required("state is required"),
    zipcode: string().required("zipcode is required"),
    // gothram: string().required('gothram is required'),
    // nakshatram: string().required('nakshatram is required'),
    phoneNumber: string()
      .required("Phone Number is required")
      .matches(/^\d{10}$/, "Phone Number should be 10 digits"),
    // chandramana: string().required('chandramana is required'),
    // souramana: string().required('souramana is required'),
  });

  const [formData, setFormData] = useState(formFields);

  const { userName } = useParams();
  const finalUserName =
    hasManagerLevelRole && isNil(userName) ? getDevoteeId().userId : userName;

  const [userData, setUserData] = useState(formFields);

  const navigate = useNavigate();
  const [selectedEventname, setSelectedEventName] = useState("");
  const [selectedEventId, setSelectedEventId] = useState(0);
  const [dateRequired, setDateRequired] = useState(false);
  const [relationName, setRelationName] = useState("");
  const [relationId, setRelationId] = useState(0);
  const [showDateAndRelationFeild, setShowDateAndRelationFeild] =
    useState(true);

  // useEffect(()=>{
  //    if(!checkAuthToken()) {
  //       navigate('/')
  //    }
  // },[getaccessToken()])

  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const [isDatePickerWedingOpen, setDatePickerWedingOpen] = useState(false);
  const [datePickerClickSpecialEvent, setDatePickerClickSpecialEvent] =
    useState(false);

  const handleDatePickerClick = () => {
    setDatePickerOpen(true);
  };

  const handleDatePickerClickSpecialEvent = () => {
    setDatePickerClickSpecialEvent(true);
  };

  const handleDatePickerWedingClick = () => {
    setDatePickerWedingOpen(true);
  };

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.nakshatramListApi,
      // includeToken: true,
    })
      .then((res) => {
        setNakshatramList(res.data.content);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  // Languages Dropdown API....
  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.languages,
      // includeToken: true,
    })
      .then((res) => {
        setLanguageItems(res.data.content);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  // Special Events Relations API...
  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.relationsList,
      params: {
        sortBy: "id",
        page: 0,
        size: 100,
        direction: "asc",
      },
      // includeToken: true,
    })
      .then((res) => {
        setRelationList(res.data.content);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  // Special Events Dropdown API...
  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.getSubscribableEvents,
      includeToken: true,
      params: {
        username: finalUserName,
      },
    })
      .then((res) => {
        setSpecialEventsList(res.data);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  // Get Special Events Details By Id GET...
  const getSpecialEventDetailsById = (id: number | null) => {
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.getDevoteeSubscriptionsById}/${id}`,
      includeToken: true,
      params: {
        username: finalUserName,
      },
    })
      .then((res) => {
        const userData = res.data;
        // setSelectedEvent({
        //   ...selectedEvent,
        //   eventName: userData.subscribedEvent,
        //   isDateDependent: userData.subscriptionDate,
        //   relation: userData.relation,
        // });
        // setSelectedRelation({
        //   ...selectedRelation,
        //   relation: userData.relation,
        // })
        setSelectedEventName(userData.subscribedEvent);
        setRelationName(userData.relation);
        setSelectedDate(userData.subscriptionDate);
        const selectedEvent = specialEventsList.find(
          (event: specialEventsListProps) =>
            event.eventName === userData.subscribedEvent
        );
        setButtonDisable(false);
        if (selectedEvent) {
          setSelectedEventId(selectedEvent.id);
          setDateRequired(selectedEvent.isDateDependent);
          setSelectedEventName(selectedEvent.eventName);
        }
        const selectedRelation = relationList.find(
          (relation: relationListProps) => relation.name === userData.relation
        );
        if (selectedRelation) {
          setRelationId(selectedRelation.id);
          // setRelationName(selectedRelation.name);
        }
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  // Special Events Table Data GET...
  const getSpecialEventsTableData = () => {
    apiRequest({
      method: "GET",
      endpoint: `${
        apiPath.devoteeSubscriptions
      }/${finalUserName?.toUpperCase()}`,
      includeToken: true,
      params: {
        username: finalUserName,
      },
    })
      .then((res) => {
        setSpecialEventsDataList(res.data);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleGetSpecialData = (id: number | null) => {
    setSelectedSpecialId(id);
    setShowAddMoreFields(true);
    getSpecialEventDetailsById(id);
    setShowAddButton(false);
    setShowSpecialAddMoreButton(false);
  };

  const handleDeleteSpecialEvents = () => {
    deleteSpecialEventApiCall();
  };

  // Special Events DELETE API....
  const deleteSpecialEventApiCall = () => {
    apiRequest({
      method: "DELETE",
      endpoint: `${apiPath.devoteeDeleteSubscriptions}/${selectedSpecialId}`,
      includeToken: true,
      params: {
        username: finalUserName,
      },
    })
      .then((res) => {
        const successMessage = LOCALE.SPECELEVENTS_DELETED;
        // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
        //   duration: 10000,
        // });
        toast.custom(
          <SuccessPopup
            headerMessage="User Events"
            showMessage={successMessage}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        getSpecialEventsTableData();
        setShowSpecialAddMoreButton(true);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  // Add Special Events API POST.......
  const addSpecialEventsApiCall = () => {
    const reqBody = {
      eventId: selectedEventId,
      date: dateRequired ? selectedDate : "",
      relationId: relationId,
    };
    apiRequest({
      method: "POST",
      endpoint: apiPath.specialEventsAddApi,
      body: JSON.stringify(reqBody),
      includeToken: true,
      params: {
        username: finalUserName,
      },
    })
      .then((res) => {
        const successMessage = LOCALE.SPECIAL_EVENTS_ADDED_SUCCESS;
        // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
        //   duration: 10000,
        // });
        toast.custom(
          <SuccessPopup
            headerMessage="User Events"
            showMessage={successMessage}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        getSpecialEventsTableData();
        setShowAddMoreFields(false);
        setButtonDisable(true);
        setShowSpecialAddMoreButton(true);
        setSelectedEventName("");
        setSelectedDate("");
        setRelationName("");
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        setButtonDisable(true);
      });
  };

  const getFamilyDetails = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.familyMembersTableDetailsApi,
      includeToken: true,
      params: {
        username: finalUserName,
      },
    })
      .then((res) => {
        setFamilyData(res.data);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleGetFamilyData = (id: number | null) => {
    setFamilyId(id);
    setUpdateButton(true);
    setShowFamilyForm(true);
    setShowFamilyAddMoreButton(false);
  };

  let emailInputLabel;
  if (!hasManagerLevelRole) {
      emailInputLabel = CustomRequiredInputLabel("Email", true);
  } else {
      emailInputLabel = CustomRequiredInputLabel("Email", false);
  }

  let phoneNumberInputLabel;
  if (!hasManagerLevelRole) {
    phoneNumberInputLabel = CustomRequiredInputLabel("Contact No", true);
  } else {
    phoneNumberInputLabel = CustomRequiredInputLabel("Contact No", false);
  }

  const handleCancel = () => {
    fetchData();
    setChangesMade(false);
  };

  const fetchData = () => {
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.getDevoteeDetails}/${finalUserName?.toUpperCase()}`,
      includeToken: true,
    })
      .then((res) => {
        const userFromApi = res.data;
        setFormData({
          ...formData,
          firstName: userFromApi.firstname,
          middleName: userFromApi.middleName || "",
          lastName: userFromApi.lastname,
          dateOfBirth: userFromApi.dateOfBirth,
          weddinganniversary: userFromApi.weddingAnniversary,
          preferedlanguage: userFromApi.preferredLanguage,
          nakshatram: userFromApi.nakshatram,
          gothram: userFromApi.gothram,
          chandramana: userFromApi.chandramana,
          souramana: userFromApi.souramana,
          address: userFromApi.address,
          city: userFromApi.city,
          state: userFromApi.state,
          zipcode: userFromApi.zipcode,
          country: "USA",
          email: userFromApi.email,
          phoneNumber: userFromApi.phoneWork,
          // phoneNumber: userFromApi.phoneWork.startsWith("1") ? ("1"+userFromApi.phoneWork) : userFromApi.phoneWork,
        });
        getSpecialEventsTableData();
        getFamilyDetails();
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  useEffect(() => {
    if (finalUserName) {
      fetchData();
    }
  }, [finalUserName]);

  const handleDelete = () => {
    deleteApiCall();
  };

  const deleteApiCall = () => {
    apiRequest({
      method: "DELETE",
      endpoint: `${apiPath.familyMemberApi}/${selectedId}`,
      includeToken: true,
      params: {
        username: finalUserName,
      },
    })
      .then((res) => {
        const successMessage = LOCALE.FAMILY_DETAILS_DELETED;
        // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
        //   duration: 10000,
        // });
        toast.custom(
          <SuccessPopup
            headerMessage="User Events"
            showMessage={successMessage}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        getFamilyDetails();
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const openDialog = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const handleAgree1 = () => {
    if (selectedId !== null) {
      // Find the index of the item with the selected ID in the addedItemsList
      const indexToRemove = familyData.findIndex(
        (item) => item.id === selectedId
      );
      handleDelete();

      if (indexToRemove !== -1) {
        // Create a copy of the addedItemsList without the selected item
        const updatedList = [...familyData];
        updatedList.splice(indexToRemove, 1);

        // Update the addedItemsList and recalculate the total donation amount
        setFamilyMemberList(updatedList);
      }
    }
    // Close the dialog
    handleClose();
  };
  
  const handleKeyDown = (e:any, fieldName:string) => {
    // Prevent entering numeric characters, spaces, and specific special characters
    if (
      (e.key >= "0" && e.key <= "9") ||
      e.key === " " || // prevent spaces
      /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-=`|"\s]/.test(e.key) // prevent specific special characters and whitespace
    ) {
      e.preventDefault();
    }
  };

  console.log(formData, "formData........");
  useEffect(() => {
    setDatePickerOpen(false);
  }, [formData.dateOfBirth]);

  useEffect(() => {
    setDatePickerWedingOpen(false);
  }, [formData.weddinganniversary]);

  const dialogPopup1 = () => {
    return (
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            height: "calc(100% - 128px)",
            width: "calc(100% - 128px)",
            margin: "64px",
            maxWidth: "504px",
            maxHeight: "180px",
            overflowY: "unset",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          },
        }}
      >
        <DialogTitle className={commonStyles.dialogTitle}>
          {"Please Confirm"}

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 24,
              top: 12,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            className={commonStyles.dialogContext}
          >
            Are You Sure want to remove the Family Member ?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <CommonOutlinedButton onClick={handleClose}>No</CommonOutlinedButton>
          <CommonButton onClick={handleAgree1}>Yes</CommonButton>
        </DialogActions>
      </Dialog>
    );
  };

  const deleteItem = () => {
    // Replace this with your actual delete logic
    alert("Item deleted!");
    // deleteApiCall()
    closeDialog();
  };

  const DeleteDialog: React.FC<DeleteDialogProps> = ({
    isOpen,
    onClose,
    onDelete,
  }) => {
    return (
      <div
        style={{
          display: isOpen ? "block" : "none",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          backgroundColor: "#fff",
          border: "1px solid #ccc",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
          zIndex: 1000,
        }}
      >
        <p>Are you sure you want to delete?</p>
        <div style={{ display: "flex", gap: "1rem" }}>
          <CommonButton onClick={onDelete}>Yes</CommonButton>
          <CommonButton onClick={onClose}>No</CommonButton>
        </div>
        {dialogPopup()}
      </div>
    );
  };
  const handleSave = async (): Promise<void> => {
    const errors: ErrorMessageTypes = { ...formFields };

    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);

      // Call your API or perform other actions here
      saveApiCall();
      if (!hasManagerLevelRole) {
        sessionStorage.setItem(
          "name",
          `${formData.firstName} ${formData.middleName} ${formData.lastName}`
        );
        sessionStorage.setItem("firstAndLastName", `${formData.firstName} ${formData.lastName}` );
      }
    } catch (error: any) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e: any) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const updateSpecialApiCall = () => {
    const reqBody = {
      id: selectedSpecialId,
      eventId: selectedEventId,
      date: selectedDate,
      relationId: relationId,
    };
    apiRequest({
      method: "PUT",
      endpoint: apiPath.specialEventsUpdateApi,
      body: JSON.stringify(reqBody),
      includeToken: true,
      params: {
        username: finalUserName,
      },
    })
      .then((res) => {
        const successMessage = LOCALE.SPECIALEVENTS_UPDATED;
        // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
        //   duration: 10000,
        // });
        toast.custom(
          <SuccessPopup
            headerMessage="User Events"
            showMessage={successMessage}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        getSpecialEventsTableData();
        setShowAddMoreFields(false);
        setShowSpecialAddMoreButton(true);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const saveApiCall = () => {
    const reqBody = {
      firstname: formData.firstName,
      middleName: formData.middleName || "",
      lastname: formData.lastName,
      dateOfBirth: formData.dateOfBirth,
      // dateOfBirth: "2023-12-19T09:23:54.184Z",
      weddingAnniversary: formData.weddinganniversary,
      preferredLanguage: formData.preferedlanguage,
      // phoneResidence: formData.phoneNumber,
      phoneResidence: formData.phoneNumber,
      nakshatram: formData.nakshatram,
      gothram: formData.gothram,
      address: formData.address,
      city: formData.city,
      state: formData.state,
      zipcode: formData.zipcode,
      country: formData.country,
      // phoneWork: formData.phoneNumber,
      phoneWork: formData.phoneNumber,
      email: formData.email,
      eventsSubscribed: eventsList,
      // dateOfRegistration : "",
      // relation:'',
      // updateDate : "",
    };
    apiRequest({
      method: "PUT",
      endpoint: `${
        apiPath.devoteeDetailsUpdate
      }/${finalUserName?.toUpperCase()}`,
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        const successMessage = LOCALE.DEATILS_UPDATED;
        // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
        //   duration: 3000,
        // });
        toast.custom(
          <SuccessPopup
            headerMessage="Updated Profile"
            showMessage={successMessage}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            
          />,
          {
            duration: 3000,
          }
        );
        setChangesMade(false);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const BasicDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
          onClick={handleDatePickerClick}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDatePickerOpen}
                onClose={() => setDatePickerOpen(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD"
                value={
                  formData.dateOfBirth
                    ? dayjs(formData.dateOfBirth, "MM-DD")
                    : ""
                }
                onChange={(value) => {
                  setErrorMessage({ ...errorMessage, dateOfBirth: "" });
                  handleFieldChange("dateOfBirth", value);
                }}
                disableFuture
                className={
                  errorMessage.dateOfBirth
                    ? styles.errorDateFeild
                    : styles.dateFeild
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.dateOfBirth ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.dateOfBirth}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const handleDateChange = (value: any) => {
    const formattedDate = dayjs(value, "MM-DD-YYYY");
    if (relationName) {
      setButtonDisable(false);
    } else {
      setButtonDisable(true);
    }
    setSelectedDate(
      formattedDate.isValid() ? formattedDate.format("MM-DD-YYYY") : ""
    );
  };

  useEffect(() => {
    setDatePickerClickSpecialEvent(false);
  }, [selectedDate]);

  const SpecialDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
          onClick={handleDatePickerClickSpecialEvent}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={datePickerClickSpecialEvent}
                onClose={() => setDatePickerClickSpecialEvent(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD"
                value={selectedDate ? dayjs(selectedDate, "MM-DD") : ""}
                onChange={(value) => {
                  handleDateChange(value);
                }}
                className={
                  errorMessage.dateOfBirth
                    ? styles.errorDateFeild
                    : styles.dateFeilds
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.dateOfBirth ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.dateOfBirth}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const WeddingDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%" }} className={styles.dropdownStyle}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
          onClick={handleDatePickerWedingClick}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDatePickerWedingOpen}
                onClose={() => setDatePickerWedingOpen(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD"
                value={
                  formData.weddinganniversary
                    ? dayjs(formData.weddinganniversary, "MM-DD")
                    : ""
                }
                onChange={(value) => {
                  setErrorMessage({ ...errorMessage, weddinganniversary: "" });
                  handleFieldChange("weddinganniversary", value);
                }}
                className={
                  errorMessage.weddinganniversary
                    ? styles.errorDateFeild
                    : styles.dateField
                }
                defaultValue={userData.weddinganniversary}
              />
            </DemoContainer>
          </LocalizationProvider>
          {!isEmpty(errorMessage.weddinganniversary) ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.weddinganniversary}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const handleFieldChange = (field: string, value: any) => {
    setChangesMade(true);
    if (field === "dateOfBirth" || field === "weddinganniversary") {
      const formattedDate = dayjs(value, "MM-DD-YYYY");

      setFormData({
        ...formData,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM-DD-YYYY")
          : "",
      });
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
      setChangesMade(true);
    }
  };

  const nakshatramDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropDowns}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          id="grouped-select"
          value={formData.nakshatram}
          onChange={(e) => handleFieldChange("nakshatram", e.target.value)}
          className={
            errorMessage.nakshatram ? styles.errorTextField : styles.textField
          }
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {nakshatramList.map((item: any, index: number) => (
            <CustomMenuItem key={index} value={item.nakshatramName}>
              {item.nakshatramName}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {!isEmpty(errorMessage.nakshatram) && (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.nakshatram}
          </Typography>
        )}
      </FormControl>
    );
  };

  const prefferedLanguageDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="grouped-select"
          value={formData.preferedlanguage}
          onChange={(e) =>
            handleFieldChange("preferedlanguage", e.target.value)
          }
          className={
            errorMessage.preferedlanguage
              ? styles.errorTextField
              : styles.dropdownStyle
          }
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {languageItems.map((item: any, index) => (
            <CustomMenuItem key={index} value={item.name}>
              {item.name}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {!isEmpty(errorMessage.preferedlanguage) && (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.preferedlanguage}
          </Typography>
        )}
      </FormControl>
    );
  };

  // const handleShowForm = () => {
  //    setShowFamilyForm(true);
  //    setShowFamilyButton(false);
  //    console.log('but...............');
  // };

  const handleSpecialFieldsForm = () => {
    setShowAddMoreFields(true);
    setShowAddMoreButton(false);
    setShowSpecialAddMoreButton(false);
    // setSelectedEventId(0);
    // setSelectedDate("");
    // setRelationId(0);
    setShowAddButton(true);
    setSelectedEventName("");
    setRelationName("");
    setDateRequired(false);
    setShowDateAndRelationFeild(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setIsOpenDialog(false);
    setSelectedId(null);
    setSelectedSpecialId(null);
  };
  const handleAgree = () => {
    if (selectedSpecialId !== null) {
      // Find the index of the item with the selected ID in the addedItemsList
      const indexToRemove = specialEventsDataList.findIndex(
        (item) => item.id === selectedSpecialId
      );
      handleDeleteSpecialEvents();

      if (indexToRemove !== -1) {
        // Create a copy of the addedItemsList without the selected item
        const updatedList = [...specialEventsDataList];
        updatedList.splice(indexToRemove, 1);

        // Update the addedItemsList and recalculate the total donation amount
        setSpecialEventsDataList(updatedList);
      }
    }
    // Close the dialog
    handleClose();
  };
  const dialogPopup = () => {
    return (
      <Dialog
        open={isOpenDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            height: "calc(100% - 128px)",
            width: "calc(100% - 128px)",
            margin: "64px",
            maxWidth: "504px",
            maxHeight: "180px",
            overflowY: "unset",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          },
        }}
      >
        <DialogTitle className={commonStyles.dialogTitle}>
          {"Please Confirm"}

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 24,
              top: 12,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            className={commonStyles.dialogContext}
          >
            Are You Sure want to remove the Special Event?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <CommonOutlinedButton onClick={handleClose}>No</CommonOutlinedButton>
          <CommonButton onClick={handleAgree}>Yes</CommonButton>
        </DialogActions>
      </Dialog>
    );
  };

  // const handleAddMore = () => {
  //    setShowAddMoreFields(true);
  //    setShowAddMoreButton(false);
  // };
  const handleAddFamilyMembers = () => {
    setShowFamilyForm(true);
    setShowFamilyButton(false);
    setFamilyId(null);
  };
  const openConfirmPopUp = (id: number | undefined | null) => {
    setSelectedId(id);
    setIsOpen(true);
  };

  const openConfirmPopUp1 = (id: number | undefined | null) => {
    setSelectedSpecialId(id);
    setIsOpenDialog(true);
  };

  const emptyPageAddFamilyButton = (): React.ReactElement => {
    return (
      <div>
        <CommonButton
          className={styles.addfamilyButton}
          onClick={handleAddFamilyMembers}
        >
          Add Family
        </CommonButton>
      </div>
    );
  };

  const emptyPageAddEventsButton = (): React.ReactElement => {
    return (
      <div>
        <CommonButton
          className={styles.addfamilyButton}
          onClick={handleSpecialFieldsForm}
        >
          Add More
        </CommonButton>
      </div>
    );
  };

  const handleChangeEvent = (e: any) => {
    setSelectedEventName(e.target.value);
    const selectedEvent = specialEventsList.find(
      (event: specialEventsListProps) => event.eventName === e.target.value
    );

    if (selectedEvent) {
      if (selectedEvent.isDateDependent && selectedDate && selectedRelation) {
        setButtonDisable(false);
      } else if (!selectedEvent.isDateDependent) {
        setButtonDisable(false);
      }
      setSelectedEventId(selectedEvent.id);
      setDateRequired(selectedEvent.isDateDependent);
      setSelectedEventName(selectedEvent.eventName);
      if (!selectedEvent.isDateDependent) {
        setShowDateAndRelationFeild(false);
      } else {
        setShowDateAndRelationFeild(true);
      }
    }
  };

  const handleChangeRelation = (e: any) => {
    // setSelectedRelation(e.target.value);
    const selectedRelation = relationList.find(
      (relation: relationListProps) => relation.name === e.target.value
    );
    if (selectedRelation) {
      selectedDate && setButtonDisable(false);
      setRelationId(selectedRelation.id);
      setRelationName(selectedRelation.name);
    }
  };

  const SpecialEventsList = (): React.ReactElement => {
    return (
      <FormControl
        sx={{
          width: "100%",
          border: "1px solid rgba(136, 46, 20, 0.40)",
          borderRadius: "8px",
        }}
      >
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="grouped-select"
          onChange={handleChangeEvent}
          value={selectedEventname}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {specialEventsList.map((item: specialEventsListProps, i: number) => (
            <CustomMenuItem value={item.eventName} key={i}>
              {item.eventName}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const RelationDropdown = (): React.ReactElement => {
    return (
      <FormControl
        sx={{
          width: "100%",
          border: "1px solid rgba(136, 46, 20, 0.40)",
          borderRadius: "8px",
        }}
      >
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="grouped-select"
          onChange={handleChangeRelation}
          value={relationName}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {relationList.map((item: relationListProps, i: any) => (
            <CustomMenuItem value={item.name} key={i}>
              {item.name}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const specialEvents = () => {
    return (
      <>
        <Grid container spacing={2} sx={{ marginTop: "0px", display: "flex" }}>
          <Grid xs={12} sm={3} item>
            <CustomInputLabel>Events</CustomInputLabel>
            {SpecialEventsList()}
          </Grid>
          {showDateAndRelationFeild ? (
            <>
              <Grid xs={12} sm={3} item>
                <CustomInputLabel>Date</CustomInputLabel>
                {SpecialDatePicker()}
              </Grid>
              <Grid xs={12} sm={3} item>
                <CustomInputLabel>Relation</CustomInputLabel>
                {RelationDropdown()}
              </Grid>
            </>
          ) : (
            ""
          )}
          {showAddButton ? (
            <CommonButton
              sx={{ marginTop: "43px", marginLeft: "20px" }}
              onClick={addSpecialEventsApiCall}
              disabled={buttonDisable}
            >
              Add
            </CommonButton>
          ) : (
            <CommonButton
              sx={{ marginTop: "43px", marginLeft: "20px" }}
              onClick={updateSpecialApiCall}
              disabled={buttonDisable}
            >
              Save
            </CommonButton>
          )}
        </Grid>
      </>
    );
  };

  const zipCodeApi = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cityAndStateApi,
      params: {
        zip: formData.zipcode,
      },
    })
      .then((res) => {
        setFormData({
          ...formData,
          state: res.data.stateName,
          city: res.data.city,
        });
      })
      .catch((err) => {
        setErrorMessage({
          ...errorMessage,
          zipcode: catchErrorMessageHandler(err),
        });
        setFormData({
          ...formData,
          state: "",
          city: "",
        });
      });
  };

  const validateEmail = () => {
    const { email } = formData;

    if (email.length < 6) {
      setErrorMessage({
        ...errorMessage,
        email: "Email must be at least 6 characters long.",
      });
    } else if (email.length >= 64) {
      setErrorMessage({
        ...errorMessage,
        email: "Email must be less than 64 characters long.",
      });
    } else if (!email.includes("@")) {
      setErrorMessage({
        ...errorMessage,
        email: "Please Enter Valid Email",
      });
    } else {
      setErrorMessage({ ...errorMessage, email: "" });
    }
  };

  const tableDataComponent = (): JSX.Element => {
    return (
      <div className={styles.table}>
        {/* <Typography className={styles.listHeading}>
          List of Item Added
        </Typography> */}
        {specialEventsDataList.length > 0 ? (
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Event Name</th>
                <th className={styles.tableHorizontal}>Date</th>
                <th className={styles.tableHorizontal}>Relation</th>
                <th className={styles.tableHorizontal}>Action</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {specialEventsDataList.map((item, index: number) => (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.tableDiagonal}>
                    {item.subscribedEvent}
                  </td>
                  <td className={styles.tableDiagonal}>
                    {/* {item.subscriptionDate} */}
                    {item.subscriptionDate
                      ? item.subscriptionDate.split("-").slice(0, 2).join("-")
                      : ""}
                  </td>
                  <td className={styles.tableDiagonal}>{item.relation}</td>

                  <td className={styles.tableDiagonal}>
                    <img
                      src={updateIcon}
                      onClick={() => handleGetSpecialData(item?.id)}
                    />
                    <img
                      src={deleteIcon}
                      onClick={() => openConfirmPopUp1(item?.id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No Items Selected</p>
        )}
      </div>
    );
  };

  const tableFamilyDataComponent = (): JSX.Element => {
    return (
      <div className={styles.table}>
        {familyData.length > 0 ? (
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Name</th>
                <th className={styles.tableHorizontal}>Gothram</th>
                <th className={styles.tableHorizontal}>Nakshatram</th>
                <th className={styles.tableHorizontal}>Relation</th>
                <th className={styles.tableHorizontal}>Email</th>
                <th className={styles.tableHorizontal}>DOB</th>
                <th className={styles.tableHorizontal}>Action</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {familyData.map((item, index: number) => (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.tableDiagonal}>
                    {item.firstname} {item.middleName} {item.lastname}
                  </td>
                  <td className={styles.tableDiagonal}>{item.gothram}</td>
                  <td className={styles.tableDiagonal}>{item.nakshatram}</td>
                  <td className={styles.tableDiagonal}>{item.relation}</td>
                  <td className={styles.tableDiagonal}>{item.email}</td>
                  <td className={styles.tableDiagonal}>
                    {item.dateOfBirth
                      ? item.dateOfBirth.split("-").slice(0, 2).join("-")
                      : ""}
                  </td>
                  <td className={styles.tableDiagonal}>
                    <img
                      src={updateIcon}
                      onClick={() => handleGetFamilyData(item?.id)}
                    />
                    <img
                      src={deleteIcon}
                      onClick={() => openConfirmPopUp(item?.id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No Items Selected</p>
        )}
      </div>
    );
  };

  return (
    <div className={styles.BoxContainer}>
      <ToastComponent />
      <DeleteDialog
        isOpen={isDialogOpen}
        onClose={closeDialog}
        onDelete={deleteItem}
      />
      <div style={{ display: "flex" }}>
        <Typography component="div" className={styles.typoGraphyHeading}>
          Edit Profile
        </Typography>
        <div style={{ marginLeft: "auto" }}>
          <CommonOutlinedButton
            sx={{ marginRight: "10px" }}
            onClick={handleCancel}
          >
            Reset
          </CommonOutlinedButton>
          <CommonButton
            className={commonStyles.saveButton}
            onClick={handleSave}
            disabled={!changesMade}
          >
            Update Profile
          </CommonButton>
        </div>
      </div>
      <div className={styles.formContainer}>
        <Typography component="div" className={styles.typoGraphySubheading}>
          Basic Information
        </Typography>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid xs={12} sm={3} item>
            {CustomRequiredInputLabel("First Name", true)}
            <CustomTextFeild
              fullWidth
              required
              value={formData.firstName}
              onChange={(e: any) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 50) {
                  setErrorMessage({ ...errorMessage, firstName: "" });
                  handleFieldChange("firstName", inputValue);
                } else {
                  setErrorMessage({
                    ...errorMessage,
                    firstName: "Maximum allowed characters is 50.",
                  });
                }
              }}
              onKeyDown={(e) => handleKeyDown(e, "firstName")}
              className={
                errorMessage.firstName
                  ? styles.errorTextField
                  : styles.textField
              }
              placeholder="Enter Firstname"
            />
            {!isEmpty(errorMessage.firstName) && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.firstName}
              </Typography>
            )}
          </Grid>
          <Grid xs={12} sm={3} item>
            {CustomRequiredInputLabel("Middle Name", false)}
            <CustomTextFeild
              className={styles.textField}
              fullWidth
              required
              value={formData.middleName}
              onChange={(e: any) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 50) {
                  setErrorMessage({ ...errorMessage, middleName: "" });
                  handleFieldChange("middleName", inputValue);
                } else {
                  setErrorMessage({
                    ...errorMessage,
                    middleName: "Maximum allowed characters is 50.",
                  });
                }
              }}
              onKeyDown={(e) => handleKeyDown(e, "firstName")}
              placeholder="Enter Middlename"
            />
            {!isEmpty(errorMessage.middleName) && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.middleName}
              </Typography>
            )}
          </Grid>
          <Grid xs={12} sm={3} item>
            {CustomRequiredInputLabel("Last Name", true)}
            <CustomTextFeild
              fullWidth
              required
              value={formData.lastName}
              onChange={(e: any) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 50) {
                  setErrorMessage({ ...errorMessage, lastName: "" });
                  handleFieldChange("lastName", inputValue);
                } else {
                  setErrorMessage({
                    ...errorMessage,
                    lastName: "Maximum allowed characters is 50.",
                  });
                }
              }}
              onKeyDown={(e) => handleKeyDown(e, "firstName")}
              className={
                errorMessage.lastName ? styles.errorTextField : styles.textField
              }
              placeholder="Enter Lastname"
            />
            {!isEmpty(errorMessage.lastName) && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.lastName}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid item xs={12} sm={3} sx={{ marginTop: "12px" }}>
            {CustomRequiredInputLabel("DOB", true)}
            {BasicDatePicker()}
          </Grid>
          <Grid item xs={12} sm={3} sx={{ marginTop: "14px" }}>
            <CustomInputLabel>Wedding Annivresary</CustomInputLabel>
            {WeddingDatePicker()}
          </Grid>
          <Grid item xs={12} sm={3} sx={{ marginTop: "14px" }}>
            <CustomInputLabel>Preffered Language</CustomInputLabel>
            {prefferedLanguageDropdown()}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid item xs={12} sm={3}>
            <CustomInputLabel>Nakshatram</CustomInputLabel>
            {nakshatramDropdown()}
          </Grid>
          <Grid xs={12} sm={3} item>
            {CustomRequiredInputLabel("Gothram", false)}
            <CustomTextFeild
              fullWidth
              required
              value={formData.gothram}
              onChange={(e: any) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 25) {
                  setErrorMessage({ ...errorMessage, gothram: "" });
                  handleFieldChange("gothram", inputValue);
                } else {
                  setErrorMessage({
                    ...errorMessage,
                    gothram: "Gothram cannot exceed 25 characters",
                  });
                }
              }}
              className={
                errorMessage.gothram ? styles.errorTextField : styles.textField
              }
              sx={{ marginTop: "10px" }}
              placeholder="Enter Gothram"
            />
            {!isEmpty(errorMessage.gothram) && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.gothram}
              </Typography>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
            sx={{ display: "flex", alignItems: "center", marginTop: "25px" }}
          >
            <CustomCheckbox disabled={true} />
            <CustomInputLabel>Chandramana</CustomInputLabel>
            <CustomCheckbox disabled={true} />
            <CustomInputLabel>Souramana</CustomInputLabel>
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: "100%",
            background: "#C1C1C1",
            height: "1px",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        />

        <Typography component="div" className={styles.typoGraphy}>
          Contact Info
        </Typography>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("Zip Code", true)}
            <CustomTextFeild
              fullWidth
              required
              value={formData.zipcode}
              onChange={(e) => {
                const inputValue = e.target.value;
                // Only allow numbers
                const sanitizedInput = inputValue
                  .replace(/[^0-9]/g, "")
                  .slice(0, 10);
                handleFieldChange("zipcode", sanitizedInput);
              }}
              className={
                errorMessage.zipcode ? styles.errorTextField : styles.textField
              }
              onBlur={zipCodeApi}
              placeholder="Enter Zipcode"
            />
            {!isEmpty(errorMessage.zipcode) && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.zipcode}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("City", true)}
            <CustomCityStateTextField
              fullWidth
              required
              value={formData.city}
              onChange={(e) => handleFieldChange("city", e.target.value)}
              className={
                errorMessage.city ? styles.errorTextField : styles.textField
              }
              InputProps={{
                readOnly: true,
              }}
            />
            {!isEmpty(errorMessage.city) && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.city}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("State", true)}
            <CustomCityStateTextField
              fullWidth
              required
              value={formData.state}
              onChange={(e) => handleFieldChange("state", e.target.value)}
              className={
                errorMessage.state ? styles.errorTextField : styles.textField
              }
              InputProps={{
                readOnly: formData.zipcode ? true : false,
              }}
              // InputProps={{
              //    readOnly: true,
              //  }}
            />
            {!isEmpty(errorMessage.state) && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.state}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("Country", true)}
            <CustomTextFeild
              fullWidth
              required
              value={formData.country}
              onChange={(e) => handleFieldChange("country", e.target.value)}
              className={
                errorMessage.country ? styles.errorTextField : styles.textField
              }
            />
            {!isEmpty(errorMessage.country) && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.country}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel("Address", false)}
            <CustomTextFeild
              fullWidth
              required
              value={formData.address}
              onChange={(e: any) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 100) {
                  setErrorMessage({ ...errorMessage, address: "" });
                  handleFieldChange("address", inputValue);
                } else {
                  setErrorMessage({
                    ...errorMessage,
                    address: "Address cannot exceed 100 characters",
                  });
                }
              }}
              className={
                errorMessage.address ? styles.errorTextField : styles.textField
              }
              placeholder="Enter Address"
            />
            {!isEmpty(errorMessage.address) && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.address}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}></Grid>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid item xs={12} sm={3}>
          {CustomRequiredInputLabel("Contact No", true)}
            <CustomTextFeild
              fullWidth
              required
              value={formData.phoneNumber}
              onChange={(e) => {
                const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
                handleFieldChange("phoneNumber", slicedNumber);
              }}
              className={
                errorMessage.phoneNumber
                  ? styles.errorTextField
                  : styles.textField
              }
              placeholder="Enter Phonenumber"
            />
            {!isEmpty(errorMessage.phoneNumber) && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.phoneNumber}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
          {CustomRequiredInputLabel("Email", true)}
            <CustomTextFeild
              fullWidth
              required
              value={formData.email}
              onBlur={validateEmail}
              onChange={(e) => handleFieldChange("email", e.target.value)}
              className={
                errorMessage.email ? styles.errorTextField : styles.textField
              }
              placeholder="Enter Email"
            />
            {!isEmpty(errorMessage.email) && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.email}
              </Typography>
            )}
          </Grid>
        </Grid>
      </div>

      <Divider
        sx={{
          width: "100%",
          background: "#C1C1C1",
          height: "1px",
          marginTop: "20px",
          marginBottom: "20px",
        }}
      />

      <Typography
        sx={{ marginTop: "20px", marginBottom: "20px" }}
        component="div"
        className={styles.typoGraphy}
      >
        Special Events
      </Typography>
      <div className={styles.familyDetails}>
        {specialEventsDataList.length === 0 ? (
          !showSpecialEventsForm ? (
            <EmptyPage
              imgUrl={familyIcon}
              subComponent={emptyPageAddEventsButton()}
              typographyText={""}
            />
          ) : null
        ) : (
          // <GridTableComponent tableData={specialEventsData} columnMapping={columnMapping} />
          <div>{tableDataComponent()}</div>
        )}
      </div>
      {showAddMoreFields ? specialEvents() : ""}
      {specialEventsDataList.length !== 0 ? (
        showSpecialAddMoreButton ? (
          <CommonButton
            sx={{ marginTop: "10px" }}
            onClick={handleSpecialFieldsForm}
          >
            Add More
          </CommonButton>
        ) : null
      ) : (
        ""
      )}
      <div style={{ marginTop: "10px", float: "right" }}>{dialogPopup()}</div>

      <Typography
        sx={{ marginTop: "20px", marginBottom: "20px" }}
        className={styles.typoGraphy}
      >
        Family Members
      </Typography>
      <div className={styles.familyDetails}>
        {familyData.length === 0 ? (
          !showFamilyForm ? (
            <EmptyPage
              imgUrl={familyIcon}
              subComponent={emptyPageAddFamilyButton()}
              typographyText={""}
            />
          ) : null
        ) : (
          <div>{tableFamilyDataComponent()}</div>
        )}
      </div>
      <div className={styles.familyDetails}>
        {showFamilyForm ? (
          <FamilyDetails
            familyData={familyData}
            setFamilyData={setFamilyData}
            getFamilyDetails={getFamilyDetails}
            id={familyId}
            setShowFamilyForm={setShowFamilyForm}
            edit={updateButton}
            setShowFamilyAddMoreButton={setShowFamilyAddMoreButton}
          />
        ) : null}
      </div>
      {familyData.length !== 0 ? (
        showFamilyAddMoreButton ? (
          <CommonButton
            sx={{ marginTop: "10px" }}
            onClick={handleAddFamilyMembers}
          >
            Add More
          </CommonButton>
        ) : null
      ) : (
        ""
      )}
      {dialogPopup()}
      {dialogPopup1()}
    </div>
  );
}
